<template>
  <div class="wlx-stu-my-cerfity-wrapper clearfix">
    <div v-for="(item,index) in certificateList" :key="index" class="my-cerfity-img-con fl" @click="IsShow(item.CertificateCover)">
        <img :src="item.CertificateCover" class="cerfity-img-val"/>
    </div>
    <div v-if="imgShow" style="width:100%;height:100%;position: fixed;top:0;left:0;z-index:3000;background:#808080;">
      <img id="canvasImg" style="width:100%;height:100%;" :src="CertificateCover" @click="imgShow=false;"/>
    </div>
    <div style="text-align: center;" v-if="certificateList.length == 0">
      <img src="../../../assets/images/the-last-new-nodata-imag.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      certificateList:[],
      imgShow:false,
      CertificateCover:"",
    };
  },
  components: {},
  created() {
    this.getCertificateList();
  },
  methods: {
    IsShow(url){
      debugger;
      this.CertificateCover=url;
      this.imgShow=true;
    },
    getCertificateList() {
      var that = this;
      this.$http.post("/api/XOrg/StudentManager/getCertificateList").then(function(rst) {
        if (rst.code > 0) {
          that.certificateList=rst.certificateList;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.wlx-stu-my-cerfity-wrapper{
    margin: 20px 0 0 30px;
    padding: 20px;
    background: #fff;
  .my-cerfity-img-con{
      margin: 0 20px 20px 0;;
      width: 500px;

     .cerfity-img-val{
         width: 500px;
     }
  }
}
</style>